//
//
//
//
//
//

export default {
    props: {
        type: {
            type: String,
            default: 'org'
        },
        top: {
            type: String,
            default: 0
        }
    },
    computed: {
        icon () {
            return `48_share_${this.type}`
        },
        style () {
            return {
                top: this.top + 'rem'
            }
        }
    }
}
